import script from "./RoamingSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoamingSearch.vue?vue&type=script&setup=true&lang=ts"

import "./RoamingSearch.vue?vue&type=style&index=0&id=c80c2b68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c80c2b68"]])

export default __exports__